import PropTypes from 'prop-types';
import { Alert, Button, Stack } from '@mui/material';
import { PATH_DASHBOARD } from 'src/routes/paths';
import AskAdminButton from 'src/pages/dashboard/practices/voice/AskAdminButton';
import { DESKS_TAB_QUERY } from 'src/components/outbound/dialerModel';
import { noRouteReason, noRouteView } from './dialerDisplay';

// UX-D PLUG-IN: "Pick your desk" for people who can't set desks up. UX-D (CU-869fmc59b) renders its
// picker here for non-admins; until it is merged this renders nothing, so staff see only the text
// (and the Ask an admin affordance below).
export function PickYourDeskSlot() {
    return null;
}

// The dialer's notice when the server finds no way to ring for this user (no desk chosen, no Twilio
// number). The widget shows it in place of the call form's helper text.
export default function DialerNoRouteHelp({ canCallElevate, isVoiceAdmin, reason, practiceId, callId, onChooseDesk, onCalledThem }) {
    const view = noRouteView({ canCallElevate, isVoiceAdmin, reason });
    return (
        <Alert severity="info" data-testid="dialer-no-route">
            <Stack spacing={1} alignItems="flex-start">
                <span data-testid="dialer-no-route-reason">{noRouteReason(reason, { isVoiceAdmin })}</span>
                {callId && onCalledThem && (
                    <Button size="small" variant="contained" onClick={onCalledThem} data-testid="dialer-called-them">I&apos;ve called them</Button>
                )}
                {view.chooseDesk && (
                    <Button size="small" variant="outlined" onClick={onChooseDesk} data-testid="dialer-choose-desk">Choose your desk</Button>
                )}
                {view.setUpDesks && (
                    <Button size="small" variant="outlined" component="a" href={`${PATH_DASHBOARD.user.integration}?${DESKS_TAB_QUERY}`} data-testid="dialer-set-up-desks">Set up desks</Button>
                )}
                {view.askAdmin && <PickYourDeskSlot />}
                {view.askAdmin && (callId
                    ? <AskAdminButton practiceId={practiceId} callId={callId} />
                    : !reason && <span data-testid="dialer-ask-admin">Ask a practice admin to set up calling for you.</span>)}
            </Stack>
        </Alert>
    );
}

DialerNoRouteHelp.propTypes = {
    canCallElevate: PropTypes.bool,
    isVoiceAdmin: PropTypes.bool,
    // The dialer endpoint's reason for no route (CU-869fn2wd3); '' from an older backend.
    reason: PropTypes.string,
    practiceId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    callId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChooseDesk: PropTypes.func,
    // The handset state for a call-back row: switch to "Did they answer?".
    onCalledThem: PropTypes.func,
};
DialerNoRouteHelp.defaultProps = { canCallElevate: false, isVoiceAdmin: false, reason: '', practiceId: undefined, callId: undefined, onChooseDesk: () => {}, onCalledThem: undefined };
